import React, { FC, useState } from 'react';
import { Avatar, Box, Slider } from '@mui/material';
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle';
import { Direction, TokenType } from '../../types';
import { COLORS } from '../../theme';
import useAppContext from '../../lib/hooks/useAppContext';
import { useAccount } from 'wagmi';

interface OrderConditionProps {
  orderValue: number;
  setOrderValue: (value: number) => void;
}

const TokenAvatar = ({ token }: { token: TokenType }) => (
  <Avatar
    src={token.logoURI}
    alt={token.symbol}
    style={{
      width: 24,
      height: 24,
      borderRadius: 12,
      marginRight: 8,
    }}
  />
);

export const OrderCondition: FC<OrderConditionProps> = ({
  orderValue,
  setOrderValue,
}) => {
  const { fromToken, toToken, poolInfo } = useAppContext();
  const [direction, setDirection] = useState(Direction.default);
  const {address} = useAccount()

  const price =
    direction === Direction.default
      ? parseFloat(poolInfo[1]) / parseFloat(poolInfo[0])
      : parseFloat(poolInfo[0]) / parseFloat(poolInfo[1]);

  const handleChangeDirection = () => {
    setDirection((prev) =>
      prev === Direction.default ? Direction.reverted : Direction.default,
    );
  };

  if (!fromToken || !toToken) {
    return null;
  }

  return (
    <Box textAlign="center" mt={1}>
      <Box color="#ccc" mb={1} sx={{ bgcolor: '#1a202c', borderRadius: 3 }}>
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          px={2}
          py={1}
        >
          Limit Price
        </Box>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          px={2}
          pb={1}
        >
          <Box display="flex" alignItems="center">
            {address ? <Box fontSize={20} color="white">
              {direction === Direction.default
                ? (price * orderValue).toFixed(4).replace(/\.0+$/, '')
                : (price * (1 / orderValue)).toFixed(4).replace(/\.0+$/, '')}
              &nbsp;
            </Box>:<Box fontSize={20} color="white">0&nbsp;</Box>}
            <TokenAvatar
              token={direction === Direction.default ? toToken : fromToken}
            />
          </Box>
          <Box
            sx={{
              cursor: 'pointer',
              display: 'flex',
              ml: 2,
              ':hover': { color: COLORS.fairblock },
            }}
            alignItems="center"
            onClick={() => handleChangeDirection()}
          >
            <SwapHorizontalCircleIcon fontSize="small" />
          </Box>
        </Box>

        <Box width="full" px={3}>
          <Slider
            aria-label="limit condition value"
            value={orderValue}
            onChange={(_, value) => setOrderValue(value as number)}
            valueLabelDisplay="off"
            shiftStep={price < 0.001 ? 0.1 : 0.05}
            step={price < 0.001 ? 0.1 : 0.05}
            min={1}
            max={price < 0.001 ? 2 : 1.4}
            sx={{
              '& .MuiSlider-thumb': {
                borderRadius: '1px',
              },
            }}
            size="small"
          />
        </Box>
      </Box>
    </Box>
  );
};
